export const commentActionStatus = {
  ADD_COMMENT: "add_comment",
  EDIT_COMMENT: "edit_comment",
  ADD_REPLY: "add_reply",
  EDIT_REPLY: "edit_reply"
}